import { loanApplicationRoleAssignmentsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { sortArrayByDate } from 'utils/data';

import { selectMasterCompanyId } from 'store/auth/selectors';

import { selectDealFromApplication } from '../selectors';

export const getLoanApplicationRoleAssignmentsHistoryAction = catchAsyncActionError(
  () => async (dispatch, getState) => {
    const state = getState();

    const companyId = selectMasterCompanyId(state);
    const { applicationId } = selectDealFromApplication(state);

    const { data } = await loanApplicationRoleAssignmentsApi.getLoanRoleAssignmentsHistory({
      applicationId,
      companyId,
    });

    return sortArrayByDate(data, 'date', 'desc');
  },
);
